// src/pages/goal-setting/dashboard/GoalDashboardList.tsx
import { Box, Typography } from "@mui/material";
import { useGoalDashboardContext } from "../../../../contexts/GoalSettingDashboardContext";
import { GoalSettingCard } from "./GoalSettingCard";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";


export const GoalSettingDashboardList = () => {
  const { displayedGoals } = useGoalDashboardContext();

  if (!displayedGoals || displayedGoals.length === 0) {
    return <Box textAlign="center" color="secondary" mt={4}></Box>;
  }

  return (
    <Box display="flex" flexDirection="column" gap={3} width="100%">
      {displayedGoals.map((goal) => (
        <GoalSettingCard key={goal.goalRefId} goalData={goal} />
      ))}
    </Box>
  );
};
